import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
export default {
  name: "EvolutionSplitView",
  components: {
    PercentageValue,
    EvolutionValue,
    LoadingElement
  },
  props: {
    split: Object,
    loading: Boolean
  }
};